// Configuración del juego de dominó
const defaultGameUrl = process.env.VUE_APP_GAME_URL || 'https://kubgame.dominues.com/';
const normalizedGameUrl = defaultGameUrl.endsWith('/') ? defaultGameUrl : `${defaultGameUrl}/`;

export const GAME_CONFIG = {
  // URLs
  GAME_URL: normalizedGameUrl,
  BILLAR_URL: `${normalizedGameUrl}billar/`,
  BOLAS_URL: `${normalizedGameUrl}bolas/`,
  // GAME_URL: 'http://localhost:3030/',
  API_BASE_URL: 'https://xpanelx.dominues.com/public/api',
  // API_BASE_URL: 'http://192.168.1.105:3010/api',
  DASHBOARD_URL: 'https://dominues.com/dashboard',
  // DASHBOARD_URL: 'http://localhost:8080/dashboard', // Solo para desarrollo local
  
  // Configuración de apuestas
  DEFAULT_BET_AMOUNT: 100,
  HOUSE_FEE_PERCENTAGE: 0.05, // 5%
  
  // Configuración del juego
  DEFAULT_PLAYERS: 2,
  DEFAULT_GAME_TYPE: 'draw',
  DEFAULT_POINTS: 10,
  
  // Configuración de redirección
  REDIRECT_DELAY: 3000, // 3 segundos por defecto
  REDIRECT_DELAY_WIN: 8000, // 8 segundos para ganadores (5 segundos extra con confeti)

  // Reintentos al guardar resultado en el API
  RESULT_SAVE_MAX_ATTEMPTS: 5,
  RESULT_SAVE_RETRY_BASE_DELAY_MS: 1500,
  RESULT_SAVE_PENDING_KEY: 'dominues_pending_game_result',
  
  // Mensajes
  MESSAGES: {
    WIN: '¡Estás encendido! 🔥',
    WIN_SUBTITLE: '¿Te anotas en la siguiente?',
    LOSE: '¡Casi lo logras! 🀄',
    LOSE_SUBTITLE: 'La revancha te espera. ¿Otra partida?',
    REDIRECTING: 'Volviendo a elegir mesa en 3 segundos...',
    REDIRECTING_WIN: 'Volviendo a elegir mesa en 8 segundos...',
    ERROR: 'No pudimos completar la partida',
    RESULT_SAVE_ERROR_TITLE: 'No pudimos confirmar la partida',
    RESULT_SAVE_ERROR_WIN: 'Ganaste la mesa. Revisa tu saldo en unos minutos; si no ves el premio, contacta a soporte.',
    RESULT_SAVE_ERROR_LOSE: 'Hubo un problema al cerrar la partida. Si algo no cuadra en tu saldo, contacta a soporte.',
    RESULT_SAVE_ERROR_HINT: 'Indica la hora de la partida y el código de sala, si lo recuerdas.',
    RESULT_SAVE_ERROR_REDIRECT: 'Te llevamos a elegir otra mesa en unos segundos...',
    RESULT_ALREADY_REGISTERED: 'La partida ya fue registrada.',
    CONNECTION_LOSS_TITLE: 'Perdiste la mesa por problemas de conexión',
    CONNECTION_LOSS_BODY: 'Revisa tu señal e ingresa a una nueva partida de inmediato.',
    CONNECTION_LOSS_FOOTER: 'La revancha te espera',
    CONNECTION_LOSS_SAVE_ERROR: 'Perdiste la mesa por problemas de conexión. Revisa tu señal e ingresa a una nueva partida de inmediato. La revancha te espera.',
    NOTIFY_ENTRY: '¡Entraste a la partida! Buena suerte.',
    NOTIFY_WIN: '¡Ganaste! Premio acreditado en tu saldo.',
    NOTIFY_LOSE: '¡Casi lo logras! La revancha te espera.',
    NOTIFY_SURRENDER: 'Te rendiste. Contó como derrota.',
    NOTIFY_BALANCE_UP: 'Saldo actualizado correctamente.'
  }
};

export function isConnectionLossGameData(gameData) {
  if (!gameData) return false;
  const merged = { ...(gameData.gameData || {}), ...gameData };
  const reason = String(merged.disconnectReason || '').toLowerCase();

  return Boolean(
    merged.disconnected ||
    merged.playerDisconnected ||
    merged.eliminated ||
    merged.reconnect_timeout ||
    reason.includes('conexion') ||
    reason.includes('conexión') ||
    reason.includes('reconnect') ||
    reason.includes('desconect')
  );
}

export function getConnectionLossIconHtml(sizePx = 80) {
  return `<i class="fas fa-wifi-slash" style="font-size: ${sizePx}px; color: #fff; opacity: 0.95;"></i>`;
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** No reintentar errores de autenticación (no se arreglan solos). */
export function shouldRetryGameResultSave(httpStatus) {
  if (httpStatus === 401 || httpStatus === 403) return false;
  return true;
}

// Función para calcular montos de apuesta
export function calculateBetAmounts(betAmount, isWinner, winnerPayout = null, playerCount = 2, totalPotOverride = null) {
  const count = Math.max(1, Number(playerCount) || 2);
  const totalPot = Number(totalPotOverride) > 0
    ? Number(totalPotOverride)
    : Number(betAmount || 0) * count;

  if (winnerPayout) {
    const payout = Number(winnerPayout) || 0;
    const houseFee = Math.max(0, totalPot - payout);

    return {
      betAmount,
      totalPot,
      houseFee,
      winnerAmount: isWinner ? payout : 0
    };
  }

  const houseFee = totalPot * GAME_CONFIG.HOUSE_FEE_PERCENTAGE;
  const winnerAmount = isWinner ? totalPot - houseFee : 0;

  return {
    betAmount,
    totalPot,
    houseFee,
    winnerAmount
  };
}
// Función para obtener datos del usuario
export function getUserData(store, localStorage) {
  let user = null;
  
  // Intentar obtener desde Vuex store
  if (store && store.state && store.state.user) {
    user = store.state.user;
    console.log('Usuario obtenido desde store:', user);
  }
  
  // Intentar obtener desde localStorage
  if (!user && localStorage) {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        user = JSON.parse(storedUser);
        console.log('Usuario obtenido desde localStorage:', user);
      }
    } catch (e) {
      console.error('Error parsing stored user:', e);
    }
  }
  
  // Intentar obtener token desde localStorage directamente
  if ((!user || !user.token) && localStorage) {
    const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
    if (token) {
      user = user || {};
      user.token = token;
      console.log('Token obtenido desde localStorage:', token);
    }
  }
  
  // Fallback para desarrollo
  if (!user) {
    user = {
      id: 1,
      name: 'Jugador',
      token: 'dev-token'
    };
    console.log('Usando datos de fallback:', user);
  }
  
  console.log('Datos de usuario finales:', user);
  return user;
}

// Función para obtener ID de mesa
export function getTableId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('tableId') || 1;
}

export function buildWaitingRoomUrl(tableId) {
  const id = tableId != null && tableId !== '' ? String(tableId) : '1';
  const origin = typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'https://dominues.com';
  return `${origin}/waiting-room/${id}?_nocache=${Date.now()}`;
}
